export const pwaOfflinePath = '/pwa/offline'
export const pwaSettingsPath = '/pwa/settings'
